const fixSpacedStrongRegex = /([^\\]|^)\*\*(\s*)(.*?)(\s*)\*\*/g;
function fixSpacedStrong(markdown) {
  return markdown.replace(fixSpacedStrongRegex, "$1$2**$3**$4");
}

export { fixSpacedStrong };
//# sourceMappingURL=fixSpacedStrong.js.map
